import { api } from './api';

export interface PublicPortfolioBlogSummary {
  slug: string;
  title: string;
  excerpt?: string | null;
  featuredImageUrl?: string | null;
  publishedAt?: string | null;
}

export interface PublicPortfolioBlogDetail {
  portfolioSlug: string;
  tenantName: string;
  teacherFirstName?: string | null;
  teacherLastName?: string | null;
  teacherAvatarUrl?: string | null;
  slug: string;
  title: string;
  excerpt?: string | null;
  body: string;
  featuredImageUrl?: string | null;
  publishedAt?: string | null;
}

export interface PublicPortfolioResponse {
  slug: string;
  tenantName: string;
  teacherFirstName?: string | null;
  teacherLastName?: string | null;
  teacherAvatarUrl?: string | null;
  headline?: string | null;
  aboutText?: string | null;
  introVideoUrl?: string | null;
  pricingText?: string | null;
  ctaText?: string | null;
  isPublished: boolean;
  blogs?: PublicPortfolioBlogSummary[] | null;
}

export interface CreatePortfolioAccessRequest {
  firstName?: string;
  lastName?: string;
  email: string;
  message?: string;
}

export const portfolioService = {
  async getPublicPortfolio(slug: string): Promise<PublicPortfolioResponse> {
    const response = await api.get<PublicPortfolioResponse>(`/portfolio/public/${encodeURIComponent(slug)}`);
    return response.data;
  },

  async getPublicBlogPost(portfolioSlug: string, blogSlug: string): Promise<PublicPortfolioBlogDetail> {
    const response = await api.get<PublicPortfolioBlogDetail>(
      `/portfolio/public/${encodeURIComponent(portfolioSlug)}/blogs/${encodeURIComponent(blogSlug)}`,
    );
    return response.data;
  },

  async requestAccess(slug: string, payload: CreatePortfolioAccessRequest): Promise<void> {
    await api.post(`/portfolio/public/${encodeURIComponent(slug)}/access-requests`, payload);
  },
};
